import { Typography } from "@mui/material"
import type { FC } from "react"

import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface GoodsReceiptPalletReferenceIdCellProps {
  pallet: GoodsReceiptPallet
}

export const GoodsReceiptPalletReferenceIdCell: FC<GoodsReceiptPalletReferenceIdCellProps> = ({ pallet }) => {
  return <Typography variant='body2'>{pallet.referenceId}</Typography>
}
